import { ToolbarMolecule, PageContentAtom } from '@justomx/atlas-components'

import LoaderAtom from 'components/atoms/Loader.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { ScannerMolecule } from 'components/molecule/Scanner.molecule'
import { PreparationPalletCardOrganism } from 'components/organisms/PreparationPalletCard.organism'
import { TransferProgressCard } from 'components/organisms/TransferProgressCard.organism'
import { usePreparation } from './Preparation.hook'

const PreparationPage = () => {
  const {
    actions,
    docNum,
    palletsData,
    totalSKUs,
    loading,
    printerReady,
    warehouse
  } = usePreparation()

  return (
    <>
      {loading && <LoaderAtom>Cargando</LoaderAtom>}

      <ToolbarMolecule
        title="Preparación"
        actionIcon="ic_arrow_back"
        onAction={actions.onGoBack}
        secondaryActionIcon={
          printerReady ? 'ic_connected_printer' : 'ic_disconnected_printer'
        }
        onSecondaryAction={actions.configurePrinter}
      />

      <PageContentAtom>
        <StackAtom $direction="column" $gap={24}>
          <TransferProgressCard
            docNum={docNum}
            warehouse={warehouse}
            palletsLabel={`${Object.values(palletsData).length}`}
            productsLabel={`${totalSKUs}/${totalSKUs}`}
          />

          <InstructionsMolecule
            ordered
            lines={[
              'Imprime la etiqueta y pégala en la tarima emplayada.',
              'Escanea la etiqueta y ubicación de armado.'
            ]}
          />

          <StackAtom $direction="column" $gap={12}>
            {Object.values(palletsData).map((palletData, index) => (
              <PreparationPalletCardOrganism
                key={palletData.container}
                palletNumber={index + 1}
                totalPallets={Object.values(palletsData).length}
                palletData={palletData}
                onPrint={actions.onPrintPallet}
              />
            ))}
          </StackAtom>
        </StackAtom>

        <ScannerMolecule mode="hidden" onScan={actions.onScan} />
      </PageContentAtom>
    </>
  )
}

export default PreparationPage
